"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashLowLevelMessage = void 0;
const core_utils_1 = require("@eth-optimism/core-utils");
const hashLowLevelMessage = (message) => {
    return (0, core_utils_1.hashWithdrawal)(message.messageNonce, message.sender, message.target, message.value, message.minGasLimit, message.message);
};
exports.hashLowLevelMessage = hashLowLevelMessage;
//# sourceMappingURL=message-utils.js.map